module.exports = __webpack_public_path__ + "static/img/4.a5c17c5.png";


//////////////////
// WEBPACK FOOTER
// ./static/mo/4.png
// module id = kYMX
// module chunks = 0